import React, {Component} from 'react';
import {Row, Col, Form, FormGroup, ControlLabel, FormControl} from "react-bootstrap";
import 'rc-color-picker/assets/index.css';
import {TopButtonCancel, TopButtonSave} from "../../../../../../componentsTopsa/buttons/TopButtons";
import {TopSelect} from "../../../../../../componentsTopsa/selects/TopSelects";
import TopIf from "../../../../../../componentsTopsa/if/TopIf";
import {TopAlertInformacja} from "../../../../../../componentsTopsa/alerty/TopAlerts";
import ValidatorMessages from "../../../../../../shared/validatorMessages/ValidatorMessages";
import NumberUilities from "../../../../../../utilities/NumberUilities";
import Validator from "../../../../../../utilities/Validator";
var tinycolor = require("tinycolor2");

export default class PolaczenieEkipyForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ekipa: null,
            kierowca: null,
            zmiana:'',
            polaczenia_juz_dodane:[],
            validateMessages:[],
        };
        this.onChangeEkipa = this.onChangeEkipa.bind(this)
        this.onChangeKierowca = this.onChangeKierowca.bind(this)
        this.onChangeZmiana = this.onChangeZmiana.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.renderOptionKierowca = this.renderOptionKierowca.bind(this)
        this.renderOptionEkipa = this.renderOptionEkipa.bind(this)
        this.renderPolaczeniaJuzDodane = this.renderPolaczeniaJuzDodane.bind(this)
    }

    componentDidMount() {
        if (Boolean(this.props.polaczenie)) {
            this.setState({
                kierowca: this.props.kierowcy.find(k => k.idKi === this.props.polaczenie.idKi),
                ekipa: this.props.ekipy.find(e => e.idEk === this.props.polaczenie.idEk),
                polaczenia_juz_dodane:this.props.polaczenia.filter(p=>p.idEk === this.props.polaczenie.idEk),
                zmiana: (Boolean(this.props.polaczenie.zmiana))? this.props.polaczenie.zmiana : ''
            })

            if(Boolean(this.props.polaczenie.zmiana))
                document.getElementById('zmianaInput').value = this.props.polaczenie.zmiana
        }
    }

    componentWillReceiveProps(nextprops){
        if(nextprops.polaczenie){
            this.setState({
                kierowca: this.props.kierowcy.find(k => k.idKi === nextprops.polaczenie.idKi),
                ekipa: this.props.ekipy.find(e => e.idEk === nextprops.polaczenie.idEk),
                polaczenia_juz_dodane:this.props.polaczenia.filter(p=>p.idEk === nextprops.polaczenie.idEk),
                zmiana: (Boolean(nextprops.polaczenie.zmiana))? nextprops.polaczenie.zmiana : ''
            })
            if(Boolean(nextprops.polaczenie.zmiana))
                document.getElementById('zmianaInput').value = nextprops.polaczenie.zmiana
        }
    }

    onChangeEkipa(e) {
        this.setState({ekipa: e})
        if(e!==null){
            this.setState({
                polaczenia_juz_dodane:this.props.polaczenia.filter(p=>p.idEk === e.idEk)
            })
        }
        else{
            this.setState({polaczenia_juz_dodane:[]})
        }
    }

    onChangeKierowca(e) {
        this.setState({kierowca: e})
    }

    onChangeZmiana(e){
        this.setState({zmiana:e.target.value})
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validateMessages;
        arr.push(msg)
        this.setState({validateMessages: arr})
    }

    onClickZapisz() {

        let poprawne = true; this.state.validateMessages = [];

        if(!Boolean(this.state.ekipa)){
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wybrano ekipy')
        }

        if(!Boolean(this.state.kierowca)){
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wybrano kierowcy')
        }

        if(!Boolean(this.state.zmiana)){
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wprowadzono numeru zmiany')
        }

        if(!Validator.validateInt(this.state.zmiana)){
            poprawne = false;
            this.dodajDoValidatorMessages('Zmiana musi być liczbą całkowitą nieujemną')
        }




        if (poprawne) {

            this.setState({validateMessages:[]})

            let date = {
                "idEkSt": this.state.ekipa.idEkSt,
                "idTmSt": this.state.ekipa.idTmSt,
                "idKiSt": this.state.kierowca.idKiSt,

                "idEk": this.state.ekipa.idEk,
                "idKi": this.state.kierowca.idKi,
                "zmiana":NumberUilities.parseStringToNumber(this.state.zmiana)
            }

            if (Boolean(this.props.polaczenie)) {
                // edycja
                this.props.handleClickZapisz(date, true)
            }
            else {
                this.props.handleClickZapisz(date, false)
            }
        }
    }

    renderOptionEkipa(option) {
        let color = 'grey';

        if((tinycolor(option.kolor)).isDark()){
            color = '#ffffff'
        }
        if((tinycolor(option.kolor)).isLight()){
            color = '#000000'
        }

        return (
            <div>
                        <span className={'label label-ebus-default'}
                              style={(option.kolor.length > 1) ? {background: option.kolor, color:color} : {background: '#f5f5f5', color: '#333333'}}>
                            {option.kodEk}
                        </span>
                <span style={{marginLeft: '10px'}}>{option.nazwaEk}</span>
            </div>
        )
    }

    renderOptionKierowca(option) {
        return (
            <div>
                <span>{option.imie+ ' '+option.nazwisko}</span>
                <div className={'pull-right'}>
                    {
                        Boolean(option.status)?
                            <span style={{color:'forestgreen',fontSize:'12px'}}><i className={'fa fa-check'}></i> aktywny</span>
                            :
                            <span style={{color:'firebrick',fontSize:'12px'}}><i className={'fa fa-times'}></i> nieaktywny</span>
                    }
                </div>
            </div>
        )
    }

    renderPolaczeniaJuzDodane(){
        let prev = null;
        let arr = []
        this.state.polaczenia_juz_dodane.map(item=>{
            if(prev !== item.zmiana && item.zmiana !==null){
                prev = item.zmiana
                arr.push(item.zmiana)
            }
        })
        arr.push(null);

        return(
            <div style={{marginTop:'15px'}}>
                <TopAlertInformacja text={'Kierowcy już dodani do wybranej trasy:'}/>
            <ul>
                {arr.map(zmiana=>{
                    return <div>
                        <h5 style={{color:'gray',fontStyle:'italic', margin:'10px 0 0 0'}}>{Boolean(zmiana)? 'Zmiana '+zmiana+':' : 'Pozostali:'}</h5>
                        {
                            this.state.polaczenia_juz_dodane.filter(pz=> pz.zmiana == zmiana).map(p=>{
                                let kierowca = this.props.kierowcy.find(k=>k.idKi === p.idKi)
                                if(Boolean(kierowca)){
                                    return <li key={p.idEkk}>{kierowca.imie + ' '+ kierowca.nazwisko}</li>
                                }
                            })

                        }
                    </div>
                })}

            </ul>
            </div>
        )
    }

    render() {

        return (
            <div>
                <fieldset>
                    <div className={'fieldset-label'}>{Boolean(this.props.polaczenie) ? 'Edycja połączenia' : 'Nowe połączenie'}</div>
                <Form horizontal={true}>
                    <FormGroup>
                        <Col xs={12} sm={6} md={3} lg={3}>
                            <ControlLabel>
                                Ekipa <span className={'req'}>*</span>
                            </ControlLabel>
                            <TopSelect onChange={this.onChangeEkipa} value={this.state.ekipa} options={this.props.ekipy} valueKey={'idEk'}
                                       labelKey={'kodEk'} placeholder={'Szukaj po kodzie'} valueRenderer={this.renderOptionEkipa} optionRenderer={this.renderOptionEkipa}/>
                        </Col>
                        <Col xs={12} sm={6} md={3} lg={3}>
                            <ControlLabel>
                                Kierowca <span className={'req'}>*</span>
                            </ControlLabel>
                            <TopSelect onChange={this.onChangeKierowca} value={this.state.kierowca} options={this.props.kierowcy} valueKey={'idKi'}
                                       placeholder={'Szukaj po imieniu i nazwisku'} labelKey={'nazwisko'} valueRenderer={this.renderOptionKierowca} optionRenderer={this.renderOptionKierowca}/>
                        </Col>
                        <Col xs={12} sm={6} md={3} lg={1}>
                            <ControlLabel>
                                Zmiana <span className={'req'}>*</span>
                            </ControlLabel>
                            <FormControl type={'number'} onChange={this.onChangeZmiana} id={'zmianaInput'}/>
                        </Col>
                        <Col xs={12} sm={6} md={3} lg={3}>
                            <div className={'add-label-margin'}></div>
                            <TopButtonCancel onClick={() => {
                                this.props.handleClickAnuluj()
                            }} text={'Anuluj'}/>
                            <TopButtonSave onClick={this.onClickZapisz} text={'Zapisz'}/>
                        </Col>
                        <Col xs={12}>
                            <TopIf isTrue={this.state.polaczenia_juz_dodane.length>0}>
                                <div>{this.renderPolaczeniaJuzDodane()}</div>
                            </TopIf>
                        </Col>
                    </FormGroup>
                    <FormGroup>
                        <ValidatorMessages messages={this.state.validateMessages}/>
                    </FormGroup>
                </Form>
                </fieldset>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/zasobyConfig/ekipy/polaczenieEkipy/components/PolaczenieEkipyForm.js